import axios from 'axios';
import { TokenExpires } from './TokenExpires';

const Bankurl = process.env.REACT_APP_MDM_URL;

export const UpiVerify = async (upi_id, setAlertMessage, setErrOpen, setVerified, setAlertType, setOpenLoader, setVerifyResponse) => {
  try {
    setOpenLoader(true);
    await axios
      .post(
        `${Bankurl}/idfy-bank-verification/bank/verify_upi`,
        { vpa_id: upi_id, task_id: sessionStorage.getItem('user_code'), group_id: sessionStorage.getItem('user_code') },
        {
          headers: {
            Authorization: `${sessionStorage.getItem('UserToken')}`
          }
        }
      )
      .then((res) => {
        const request_id = res.data.details.request_id;
        if (request_id) {
          sessionStorage.setItem('request_id', request_id);
          VerifyBank_Request_id(setAlertMessage, setErrOpen, setVerified, setAlertType, setOpenLoader, setVerifyResponse, 0);
          // handleClick();
          // sessionStorage.setItem("")
        }
      });
  } catch (error) {
    TokenExpires(error)
    setOpenLoader(false);
    setAlertMessage(error.responses&&error.responses.data.error?error.responses.data.error:error.response.data.message?error.response.data.message:"Something went wrong");
    setAlertType('error');
    setErrOpen(true);
  }
};

export const BankAccNumberVerify = async (
  ifsc_code,
  account_number,
  bank_name,
  setAlertMessage,
  setErrOpen,
  setVerified,
  setAlertType,
  setOpenLoader,
  setVerifyResponse,
  // setFieldChange,
  setFieldValue
) => {
  try {
    console.log("bank_name,ifsc_code,account_number",bank_name,ifsc_code,account_number);

    setOpenLoader(true);
    await axios
      .post(
        `${Bankurl}/idfy-bank-verification/bank/verify_bank`,
        {
          ifsc_code,
          account_number,
          task_id: sessionStorage.getItem('user_code') ? sessionStorage.getItem('user_code') : 'finvesta',
          group_id: sessionStorage.getItem('user_code') ? sessionStorage.getItem('user_code') : 'finvesta'
        },
        {
          headers: {
            Authorization: `${sessionStorage.getItem('UserToken')}`
          }
        }
      )
      .then((res) => {
        setOpenLoader(false);
        const request_id = res.data.details.request_id;
        if (request_id) {
          sessionStorage.setItem('request_id', request_id);

          VerifyBank_Request_id(setAlertMessage, setErrOpen, setVerified, setAlertType, setOpenLoader, setVerifyResponse, 0, setFieldValue);
          // handleClick();
          // sessionStorage.setItem("")
        }
      });
  } catch (error) {
    TokenExpires(error)
    setOpenLoader(false);
    setAlertMessage(error.message);
    setAlertType('error');
    setErrOpen(true);
  }
};

export const DynamicBankAccNumberVerify = async (
  ifsc_code,
  account_number,
  name,
  bankusername,
  setAlertOpen,
  setErrMessage,
  setSuccessAlert,
  setFieldValue,
  handleOpenLoader,
  handleCloseLoader,
  validateField,
  ifsc_key
) => {
  // console.log('ifsc', ifsc_code);
  try {
    handleOpenLoader();
    await axios
      .post(
        `${Bankurl}/idfy-bank-verification/bank/verify_bank`,
        {
          ifsc_code,
          account_number,
          task_id: sessionStorage.getItem('user_code') ? sessionStorage.getItem('user_code') : 'finvesta',
          group_id: sessionStorage.getItem('user_code') ? sessionStorage.getItem('user_code') : 'finvesta'
        },
        {
          headers: {
            Authorization: `${sessionStorage.getItem('UserToken')}`
          }
        }
      )
      .then((res) => {
        handleCloseLoader();
        const request_id = res.data.details.request_id;
        if (request_id) {
          sessionStorage.setItem('request_id', request_id);

          DynamicVerifyBank_Request_id(
            account_number,
            ifsc_code,
            name,
            bankusername,
            setErrMessage,
            setAlertOpen,
            setFieldValue,
            setSuccessAlert,
            handleCloseLoader,
            handleOpenLoader,
            validateField,
            ifsc_key,
            0
          );
          // handleClick();
          sessionStorage.setItem('bank_acc', account_number);
        }
      });
  } catch (error) {
    TokenExpires(error)
    console.log('error', error);
    handleCloseLoader();
    setErrMessage(error.response ? error.response.data.error : 'Unable to verify your account number');
    setAlertOpen(true);
  }
};


export const DynamicBankAccNumberVerifyBharat = async (
  ifsc_code,
  account_number,
  name,
  bankusername,
  setAlertOpen,
  setErrMessage,
  setSuccessAlert,
  setFieldValue,
  handleOpenLoader,
  handleCloseLoader,
  validateField,
  ifsc_key
) => {
  // console.log('ifsc', ifsc_code);
  try {
    handleOpenLoader();
    await axios
      .post(
        `${Bankurl}/aadhar-idfy/bank-account/send-request`,
        {
          ifsc:ifsc_code,
          bank_account:account_number,

        },
        {
          headers: {
            Authorization: `${sessionStorage.getItem('UserToken')}`
          }
        }
      )
      .then((res) => {
        handleCloseLoader();
        // const request_id = res.data.details.request_id;
        if(res.data.status&&res.data.status==='SUCCESS'){
            if (res.data?.status==="SUCCESS") {
          const bankName = res.data?.beneficiary_name
            .replace(/^\s*(mr\.|mrs\.|master\.|miss\.|ms\.|dr\.|mr|mrs|master|miss|ms|dr)\s+/i, '')
            .toLowerCase().trim()
            // .replace(/\s+/g, '');
          const aadhaarName = sessionStorage.getItem('aadhaar_name').toLowerCase().trim();
          const bankWords = bankName.split(' ');
          const aadhaarWords = aadhaarName.split(' ');

          const bankFirstName = bankWords[0];
          const bankLastName = bankWords[bankWords.length - 1];

          const aadhaarFirstName = aadhaarWords[0];
          const aadhaarLastName = aadhaarWords[aadhaarWords.length - 1];

          const ValidateName = bankFirstName === aadhaarFirstName && bankLastName === aadhaarLastName;
          if (!ValidateName) {
            setErrMessage('The name does not match the name on your bank account.');
            setAlertOpen(true);
          } else if (ValidateName) {
            sessionStorage.setItem('bank_ifsc', ifsc_code);
            setFieldValue(`${name}_verify`, 'true');
            setFieldValue(bankusername, res.data?.beneficiary_name);
            setErrMessage('Account Verified Successfully');
            setSuccessAlert(true);
            sessionStorage.setItem(bankusername, res.data?.beneficiary_name);
            sessionStorage.setItem('bankusername', res.data?.beneficiary_name);
            sessionStorage.setItem(`${name}_verify`, true);
            setTimeout(() => {
              validateField(`${name}_verify`);
              sessionStorage.setItem(name, account_number);
              sessionStorage.setItem(ifsc_key, ifsc_code);
            }, 1000);
            setSuccessAlert(true);
          }
        } else{
          setErrMessage('Unable to verify account number');
          setAlertOpen(true);
        } 
        }
        else{
          DynamicVerifyBank_Request_id_Bharat(
            res,
            account_number,
            ifsc_code,
            name,
            bankusername,
            setErrMessage,
            setAlertOpen,
            setFieldValue,
            setSuccessAlert,
            handleCloseLoader,
            handleOpenLoader,
            validateField,
            ifsc_key,

        )
        }
        
        
      });
  } catch (error) {
    TokenExpires(error)
    console.log('error', error);
    handleCloseLoader();
    setErrMessage(error.response ? error.response.data.error : 'Unable to verify your account number');
    setAlertOpen(true);
  }
};

export const VerifyBank_Request_id = async (
  // bank_name,
  // ifsc_code,
  // account_number,
  setAlertMessage,
  setErrOpen,
  setVerified,
  setAlertType,
  setOpenLoader,
  setVerifyResponse,
  instance,
  // setFieldChange,
  setFieldValue,
) => {
  const request_id = sessionStorage.getItem('request_id');
  let retry = instance;
  console.log('asdefwefwbefewb');
  try {
    setOpenLoader(true);
    await axios
      .post(
        `${Bankurl}/idfy-bank-verification/bank/task_details`,
        { request_id },
        {
          headers: {
            Authorization: `${sessionStorage.getItem('UserToken')}`
          }
        }
      )
      .then((res) => {
        setOpenLoader(false);
        console.log('res.data.details.result.status', res.data.details.result.status);
        if (res.data.details.result.status === 'id_found') {
          // const bankName = res.data.details.result.name_at_bank
          //   .replace(/^\s*(mr\.|mrs\.|master\.|miss\.|ms\.|dr\.|mr|mrs|master|miss|ms|dr)\s+/i, '')
          //   .toLowerCase()
          //   .trim();
          // // .replace(/\s+/g, '')
          // const aadhaarName = sessionStorage.getItem('aadhaar_name').toLowerCase().trim();
          // // const [bankFirst, , bankLast] = bankName.split(' ');
          // // const [aadhaarFirst, , aadhaarLast] = aadhaarName.split(' ');
          // const bankWords = bankName.split(' ');
          // const aadhaarWords = aadhaarName.split(' ');

          // const bankFirstName = bankWords[0];
          // const bankLastName = bankWords[bankWords.length - 1];

          // const aadhaarFirstName = aadhaarWords[0];
          // const aadhaarLastName = aadhaarWords[aadhaarWords.length - 1];

          // const ValidateName = bankFirstName === aadhaarFirstName && bankLastName === aadhaarLastName;
          // if (!ValidateName) {
          //   setAlertMessage('The name does not match the name on your bank account.');
          //   setAlertType('error');
          //   setErrOpen(true);
          // }else if(ValidateName){
          setVerifyResponse(res.data);
          setVerified(true);
          setAlertMessage('Account Verified Successfully');
          setFieldValue('savings_account_holder_name', res.data.details.result.name_at_bank);
          // sessionStorage.setItem('savings_bank_name', bank_name);
          // sessionStorage.setItem('savings_account_ifsc_code', ifsc_code);
          // sessionStorage.setItem('savings_account_number', account_number);
          sessionStorage.setItem('savings_account_holder_name', res.data.details.result.name_at_bank);
          sessionStorage.setItem('BankAccVerified', true);
          setAlertType('success');
          // setFieldChange(false)
          setErrOpen(true);
          // }
        } else if (res.data.details.result.status === 'id_not_found') {
          setAlertMessage('Account number does not match the selected bank. Please re-enter the correct account number');
          setAlertType('error');
          setErrOpen(true);
        } else if (res.data.details.result.status === 'ind_vpa') {
          setAlertMessage('Upi id is invalid');
          setAlertType('error');
          setErrOpen(true);
        }
      });
  } catch (error) {
    TokenExpires(error)
    if (retry < 4) {
      setTimeout(() => {
        VerifyBank_Request_id(
          setAlertMessage,
          setErrOpen,
          setVerified,
          setAlertType,
          setOpenLoader,
          setVerifyResponse,
          retry + 1,
          setFieldValue
        );
      }, 4000);
    } else {
      console.log('error', error);
      setOpenLoader(false);
      setAlertMessage(error.response.data.message ? error.response.data.message : error.response.data.error? error.response.data.error: 'Unable to verify bank account number');
      setAlertType('error');
      setErrOpen(true);
    }
  }
};

export const DynamicVerifyBank_Request_id = async (
  account_number,
  ifsc_code,
  name,
  bankusername,
  setErrMessage,
  setAlertOpen,
  setFieldValue,
  setSuccessAlert,
  handleCloseLoader,
  handleOpenLoader,
  validateField,
  ifsc_key,
  instance
) => {
  const request_id = sessionStorage.getItem('request_id');
  let retry = instance;
  console.log("instaince",retry);
  
  try {
    handleOpenLoader();
    await axios
      .post(
        `${Bankurl}/idfy-bank-verification/bank/task_details`,
        { request_id },
        {
          headers: {
            Authorization: `${sessionStorage.getItem('UserToken')}`
          }
        }
      )
      .then((res) => {
        handleCloseLoader();
        if (res.data.details.result.status === 'id_found') {
          const bankName = res.data.details.result.name_at_bank
            .replace(/^\s*(mr\.|mrs\.|master\.|miss\.|ms\.|dr\.|mr|mrs|master|miss|ms|dr)\s+/i, '')
            .toLowerCase().trim()
            // .replace(/\s+/g, '');
          const aadhaarName = sessionStorage.getItem('aadhaar_name').toLowerCase().trim();
          const bankWords = bankName.split(' ');
          const aadhaarWords = aadhaarName.split(' ');

          const bankFirstName = bankWords[0];
          const bankLastName = bankWords[bankWords.length - 1];

          const aadhaarFirstName = aadhaarWords[0];
          const aadhaarLastName = aadhaarWords[aadhaarWords.length - 1];

          const ValidateName = bankFirstName === aadhaarFirstName && bankLastName === aadhaarLastName;
          if (!ValidateName) {
            setErrMessage('The name does not match the name on your bank account.');
            setAlertOpen(true);
          } else if (ValidateName) {
            sessionStorage.setItem('bank_ifsc', ifsc_code);
            setFieldValue(`${name}_verify`, 'true');
            setFieldValue(bankusername, res.data.details.result.name_at_bank);
            setErrMessage('Account Verified Successfully');
            setSuccessAlert(true);
            sessionStorage.setItem(bankusername, res.data.details.result.name_at_bank);
            sessionStorage.setItem('bankusername', res.data.details.result.name_at_bank);
            sessionStorage.setItem(`${name}_verify`, true);
            setTimeout(() => {
              validateField(`${name}_verify`);
              sessionStorage.setItem(name, account_number);
              sessionStorage.setItem(ifsc_key, ifsc_code);
            }, 1000);
            setSuccessAlert(true);
          }
        } else if (res.data.details.result.status === 'id_not_found') {
          setErrMessage('Account number does not match the selected bank. Please re-enter the correct account number');
          setAlertOpen(true);
        } else if (res.data.details.result.status === 'ind_vpa') {
          setErrMessage('Upi id is invalid');
          setAlertOpen(true);
        }
      })
      .catch((error)=>{
        TokenExpires(error)
        if (retry < 6) {
          setTimeout(() => {
            DynamicVerifyBank_Request_id(
              account_number,
              ifsc_code,
              name,
              bankusername,
              setErrMessage,
              setAlertOpen,
              setFieldValue,
              setSuccessAlert,
              handleCloseLoader,
              handleOpenLoader,
              validateField,
              ifsc_key,
              retry + 1
            );
          }, 4000);
        } else {
          // console.log("denoou",error);
          handleCloseLoader();
          setErrMessage(error.response.data.message ? error.response.data.message : error.response.data.error? error.response.data.error : 'Unable to verify your account number');
          setAlertOpen(true);
        }
      })
  } catch (error) {
    TokenExpires(error)
    if (retry < 6) {
      setTimeout(() => {
        DynamicVerifyBank_Request_id(
          account_number,
          ifsc_code,
          name,
          bankusername,
          setErrMessage,
          setAlertOpen,
          setFieldValue,
          setSuccessAlert,
          handleCloseLoader,
          handleOpenLoader,
          validateField,
          ifsc_key,
          retry + 1
        );
      }, 4000);
    } else {
      // console.log("denoou",error);
      handleCloseLoader();
      setErrMessage(error.response.data.message ? error.response.data.message : error.response.data.error? error.response.data.error : 'Unable to verify your account number');
      setAlertOpen(true);
    }
  }
};

export const DynamicVerifyBank_Request_id_Bharat = async (
  res,
  account_number,
  ifsc_code,
  name,
  bankusername,
  setErrMessage,
  setAlertOpen,
  setFieldValue,
  setSuccessAlert,
  handleCloseLoader,
  handleOpenLoader,
  validateField,
  ifsc_key,

) => {
  // const request_id = sessionStorage.getItem('request_id');
  try {
    handleOpenLoader();
    await axios
      .post(
        `${Bankurl}/aadhar-idfy/bank-account/get-status`,
        {
        request_id:res.data.request_id,
        result_id:res.data.result_id
      },
        {
          headers: {
            Authorization: `${sessionStorage.getItem('UserToken')}`
          }
        }
      )
      .then((res) => {
        handleCloseLoader();
        if (res.data?.status==="SUCCESS") {
          const bankName = res.data?.beneficiary_name
            .replace(/^\s*(mr\.|mrs\.|master\.|miss\.|ms\.|dr\.|mr|mrs|master|miss|ms|dr)\s+/i, '')
            .toLowerCase().trim()
            // .replace(/\s+/g, '');
          const aadhaarName = sessionStorage.getItem('aadhaar_name').toLowerCase().trim();
          const bankWords = bankName.split(' ');
          const aadhaarWords = aadhaarName.split(' ');

          const bankFirstName = bankWords[0];
          const bankLastName = bankWords[bankWords.length - 1];

          const aadhaarFirstName = aadhaarWords[0];
          const aadhaarLastName = aadhaarWords[aadhaarWords.length - 1];

          const ValidateName = bankFirstName === aadhaarFirstName && bankLastName === aadhaarLastName;
          if (!ValidateName) {
            setErrMessage('The name does not match the name on your bank account.');
            setAlertOpen(true);
          } else if (ValidateName) {
            sessionStorage.setItem('bank_ifsc', ifsc_code);
            setFieldValue(`${name}_verify`, 'true');
            setFieldValue(bankusername, res.data?.beneficiary_name);
            setErrMessage('Account Verified Successfully');
            setSuccessAlert(true);
            sessionStorage.setItem(bankusername, res.data?.beneficiary_name);
            sessionStorage.setItem('bankusername', res.data?.beneficiary_name);
            sessionStorage.setItem(`${name}_verify`, true);
            setTimeout(() => {
              validateField(`${name}_verify`);
              sessionStorage.setItem(name, account_number);
              sessionStorage.setItem(ifsc_key, ifsc_code);
            }, 1000);
            setSuccessAlert(true);
          }
        } else{
          setErrMessage('Unable to verify account number');
          setAlertOpen(true);
        }
      })
      .catch((error)=>{
        TokenExpires(error)

          console.log("error",error);
          handleCloseLoader();
          setErrMessage(error.response.data.message ? error.response.data.message : error.response.data.error? error.response.data.error : 'Unable to verify your account number');
          setAlertOpen(true);

      })
  } catch (error) {
    TokenExpires(error)

      // console.log("denoou",error);
      handleCloseLoader();
      setErrMessage(error.response.data.message ? error.response.data.message : error.response.data.error? error.response.data.error : 'Unable to verify your account number');
      setAlertOpen(true);

  }
};

export const BankAccNumberVerifyInProfile = async (
  ifsc_code,
  account_number,
  bank_name,
  setAlertMessage,
  setErrOpen,
  setVerified,
  setAlertType,
  setOpenLoader,
  setVerifyResponse,
  setFieldChange,
  setFieldValue
) => {
  try {
    setOpenLoader(true);
    await axios
      .post(
        `${Bankurl}/finvesta-user/submit_account_data`,
        {
          ifsc_code,
          account_number,
          task_id: sessionStorage.getItem('user_code') ? sessionStorage.getItem('user_code') : 'finvesta',
          group_id: sessionStorage.getItem('user_code') ? sessionStorage.getItem('user_code') : 'finvesta'
        },
        {
          headers: {
            Authorization: `${sessionStorage.getItem('UserToken')}`
          }
        }
      )
      .then((res) => {
        setOpenLoader(false);
        const request_id = res.data.details.request_id;
        if (request_id) {
          sessionStorage.setItem('request_id', request_id);
          VerifyBank_Request_id_Profile(
            account_number,
            ifsc_code,
            bank_name,
            setAlertMessage,
            setErrOpen,
            setVerified,
            setAlertType,
            setOpenLoader,
            setVerifyResponse,
            0,
            setFieldChange,
            setFieldValue
          );
          // sessionStorage.setItem('saving_acc_number', account_number);
          // sessionStorage.setItem('saving_ifsc_code_product', ifsc_code);
          // handleClick();
          // sessionStorage.setItem("")
        }
      });
  } catch (error) {
    TokenExpires(error)
    setOpenLoader(false);
    setAlertMessage(error.response ? error.response.data.error : 'Unable to verify bank account number');
    setAlertType('error');
    setErrOpen(true);
  }
};


export const BankAccNumberVerifyInProfileBharat = async (
  ifsc_code,
  account_number,
  bank_name,
  setAlertMessage,
  setErrOpen,
  setVerified,
  setAlertType,
  setOpenLoader,
  setVerifyResponse,
  setFieldChange,
  setFieldValue
) => {
  try {
    setOpenLoader(true);
    await axios
      .post(
        `${Bankurl}/aadhar-idfy/bank-account/verify`,
        {
          ifsc:ifsc_code,
          bank_account:account_number

        },
        {
          headers: {
            Authorization: `${sessionStorage.getItem('UserToken')}`
          }
        }
      )
      .then((res) => {
        setOpenLoader(false);
        const request_id = res.data.details.request_id;
        if (request_id) {
          sessionStorage.setItem('request_id', request_id);
          VerifyBank_Request_id_Profile(
            account_number,
            ifsc_code,
            bank_name,
            setAlertMessage,
            setErrOpen,
            setVerified,
            setAlertType,
            setOpenLoader,
            setVerifyResponse,
            setFieldChange,
            setFieldValue
          );
          // sessionStorage.setItem('saving_acc_number', account_number);
          // sessionStorage.setItem('saving_ifsc_code_product', ifsc_code);
          // handleClick();
          // sessionStorage.setItem("")
        }
      });
  } catch (error) {
    TokenExpires(error)
    setOpenLoader(false);
    setAlertMessage(error.response && error.response.data.error ? error.response.data.error : error.response.data.message?error.response.data.message : 'Unable to verify bank account number');
    setAlertType('error');
    setErrOpen(true);
  }
};


export const BankVerifySend_Request_Api = async (
  account_number,
  ifsc_code,
  bank_name,
  setAlertMessage,
  setErrOpen,
  setVerified,
  setAlertType,
  setOpenLoader,
  setVerifyResponse,
  setFieldChange,
  setFieldValue
) => {
  try {
    setOpenLoader(true);
    await axios
      .post(
        `${Bankurl}/aadhar-idfy/bank-account/send-request`,
        { bank_account:account_number,
          ifsc:ifsc_code
         },
        {
          headers: {
            Authorization: `${sessionStorage.getItem('UserToken')}`
          }
        }
      )
      .then((res) => {
        setOpenLoader(false);
        if(res.data.status&&res.data.status==='SUCCESS'){
            setOpenLoader(false)
              const bankName = res.data?.beneficiary_name
            .replace(/^\s*(mr\.|mrs\.|master\.|miss\.|ms\.|dr\.|mr|mrs|master|miss|ms|dr)\s+/i, '')
            .toLowerCase()
            .trim();
          // .replace(/\s+/g, '')
          const aadhaarName = sessionStorage.getItem('aadhaar_name').toLowerCase().trim();
          // const [bankFirst, , bankLast] = bankName.split(' ');
          // const [aadhaarFirst, , aadhaarLast] = aadhaarName.split(' ');
          const bankWords = bankName.split(' ');
          const aadhaarWords = aadhaarName.split(' ');

          const bankFirstName = bankWords[0];
          const bankLastName = bankWords[bankWords.length - 1];

          const aadhaarFirstName = aadhaarWords[0];
          const aadhaarLastName = aadhaarWords[aadhaarWords.length - 1];

          const ValidateName = bankFirstName === aadhaarFirstName && bankLastName === aadhaarLastName;
          if (!ValidateName) {
            setAlertMessage('The name does not match the name on your bank account.');
            setAlertType('error');
            setErrOpen(true);
          } else if (ValidateName) {
            setVerifyResponse(res.data);
            setVerified(true);
            setAlertMessage('Account Verified Successfully');
            setAlertType('success');
            setFieldChange(false);
            setErrOpen(true);
            setFieldValue('saving_acc_holder_name', res.data?.beneficiary_name);
            sessionStorage.setItem('BankAccVerified', true);
            sessionStorage.setItem('saving_acc_number', account_number);
            sessionStorage.setItem('saving_ifsc_code', ifsc_code);
            sessionStorage.setItem('savings_acc_bank_name', bank_name);
            sessionStorage.setItem('saving_acc_holder_name', res.data?.beneficiary_name);
            // setFieldValue('saving_acc_holder_name', res.data.details.result.name_at_bank);
          }
        }
        else{

          getStatusForBharatBankVerify(res,account_number,ifsc_code,setOpenLoader,setAlertMessage,setErrOpen,setAlertType,bank_name,setVerified,setVerifyResponse,setFieldChange,setFieldValue)
        }
       
      })
      .catch((error) => {
        TokenExpires(error)

        setAlertMessage(error.response.data.message ? error.response.data.message : error.response.data.error? error.response.data.error: 'Unable to verify bank account number');
        setAlertType('error');
        setErrOpen(true);
        setOpenLoader(false);

      });
  } catch (error) {

      TokenExpires(error)
      setOpenLoader(false);
      setAlertMessage(error.response.data.message ? error.response.data.message : error.response.data.error? error.response.data.error : 'Unable to verify bank account number');
      setAlertType('error');
      setErrOpen(true);

  }
};


export const getStatusForBharatBankVerify=async(res,account_number,ifsc_code,setOpenLoader,setAlertMessage,setErrOpen,setAlertType,bank_name,setVerified,setVerifyResponse,setFieldChange,setFieldValue)=>{
  try{
      setOpenLoader(true)
      await axios.post(`${Bankurl}/aadhar-idfy/bank-account/get-status`,{
        request_id:res.data.request_id,
        result_id:res.data.result_id
      },
        {
          headers: {
            Authorization: `${sessionStorage.getItem('UserToken')}`
          }
        })
        .then((res)=>{
          setOpenLoader(false)
          if(res.data?.status==="SUCCESS"){

            setOpenLoader(false)
              const bankName = res.data?.beneficiary_name
            .replace(/^\s*(mr\.|mrs\.|master\.|miss\.|ms\.|dr\.|mr|mrs|master|miss|ms|dr)\s+/i, '')
            .toLowerCase()
            .trim();
          // .replace(/\s+/g, '')
          const aadhaarName = sessionStorage.getItem('aadhaar_name').toLowerCase().trim();
          // const [bankFirst, , bankLast] = bankName.split(' ');
          // const [aadhaarFirst, , aadhaarLast] = aadhaarName.split(' ');
          const bankWords = bankName.split(' ');
          const aadhaarWords = aadhaarName.split(' ');

          const bankFirstName = bankWords[0];
          const bankLastName = bankWords[bankWords.length - 1];

          const aadhaarFirstName = aadhaarWords[0];
          const aadhaarLastName = aadhaarWords[aadhaarWords.length - 1];

          const ValidateName = bankFirstName === aadhaarFirstName && bankLastName === aadhaarLastName;
          if (!ValidateName) {
            setAlertMessage('The name does not match the name on your bank account.');
            setAlertType('error');
            setErrOpen(true);
          } else if (ValidateName) {
            setVerifyResponse(res.data);
            setVerified(true);
            setAlertMessage('Account Verified Successfully');
            setAlertType('success');
            setFieldChange(false);
            setErrOpen(true);
            setFieldValue('saving_acc_holder_name', res.data?.beneficiary_name);
            sessionStorage.setItem('BankAccVerified', true);
            sessionStorage.setItem('saving_acc_number', account_number);
            sessionStorage.setItem('saving_ifsc_code', ifsc_code);
            sessionStorage.setItem('savings_acc_bank_name', bank_name);
            sessionStorage.setItem('saving_acc_holder_name', res.data?.beneficiary_name);
            // setFieldValue('saving_acc_holder_name', res.data.details.result.name_at_bank);
          }
          }
          else{
                setOpenLoader(false)
                setAlertMessage('Unable to verify bank account number');
               setAlertType('error');
                setErrOpen(true);
          }

        })
  }
  catch(error){
    TokenExpires(error)
      setOpenLoader(false);
      setAlertMessage(error.response.data.message ? error.response.data.message : error.response.data.error? error.response.data.error : 'Unable to verify bank account number');
      setAlertType('error');
      setErrOpen(true);
  }
}

export const VerifyBank_Request_id_Profile = async (
  account_number,
  ifsc_code,
  bank_name,
  setAlertMessage,
  setErrOpen,
  setVerified,
  setAlertType,
  setOpenLoader,
  setVerifyResponse,
  instance,
  setFieldChange,
  setFieldValue
) => {
  const request_id = sessionStorage.getItem('request_id');
  let retry = instance;
  try {
    setOpenLoader(true);
    await axios
      .post(
        `${Bankurl}/idfy-bank-verification/bank/task_details`,
        { request_id },
        {
          headers: {
            Authorization: `${sessionStorage.getItem('UserToken')}`
          }
        }
      )
      .then((res) => {
        setOpenLoader(false);
        if (res.data.details.result.status === 'id_found') {
          const bankName = res.data.details.result.name_at_bank
            .replace(/^\s*(mr\.|mrs\.|master\.|miss\.|ms\.|dr\.|mr|mrs|master|miss|ms|dr)\s+/i, '')
            .toLowerCase()
            .trim();
          // .replace(/\s+/g, '')
          const aadhaarName = sessionStorage.getItem('aadhaar_name').toLowerCase().trim();
          // const [bankFirst, , bankLast] = bankName.split(' ');
          // const [aadhaarFirst, , aadhaarLast] = aadhaarName.split(' ');
          const bankWords = bankName.split(' ');
          const aadhaarWords = aadhaarName.split(' ');

          const bankFirstName = bankWords[0];
          const bankLastName = bankWords[bankWords.length - 1];

          const aadhaarFirstName = aadhaarWords[0];
          const aadhaarLastName = aadhaarWords[aadhaarWords.length - 1];

          const ValidateName = bankFirstName === aadhaarFirstName && bankLastName === aadhaarLastName;
          if (!ValidateName) {
            setAlertMessage('The name does not match the name on your bank account.');
            setAlertType('error');
            setErrOpen(true);
          } else if (ValidateName) {
            setVerifyResponse(res.data);
            setVerified(true);
            setAlertMessage('Account Verified Successfully');
            setAlertType('success');
            setFieldChange(false);
            setErrOpen(true);
            setFieldValue('saving_acc_holder_name', res.data.details.result.name_at_bank);
            sessionStorage.setItem('BankAccVerified', true);
            sessionStorage.setItem('saving_acc_number', account_number);
            sessionStorage.setItem('saving_ifsc_code', ifsc_code);
            sessionStorage.setItem('savings_acc_bank_name', bank_name);
            sessionStorage.setItem('saving_acc_holder_name', res.data.details.result.name_at_bank);
            // setFieldValue('saving_acc_holder_name', res.data.details.result.name_at_bank);
          }
        } else if (res.data.details.result.status === 'id_not_found') {
          setAlertMessage('Account number does not match the selected bank. Please re-enter the correct account number');
          setAlertType('error');
          setErrOpen(true);
        } else if (res.data.details.result.status === 'ind_vpa') {
          setAlertMessage('Upi id is invalid');
          setAlertType('error');
          setErrOpen(true);
        } else {
          setAlertMessage(res.data.details.result.status);
          setAlertType('error');
          setErrOpen(true);
        }
      })
      .catch((error) => {
        TokenExpires(error)
    if (retry < 4) {
        setTimeout(() => {
          VerifyBank_Request_id_Profile(
            account_number,
            ifsc_code,
            bank_name,
            setAlertMessage,
            setErrOpen,
            setVerified,
            setAlertType,
            setOpenLoader,
            setVerifyResponse,
            retry + 1,
            setFieldChange,
            setFieldValue
          );
        }, 4000);
    }else{
        setAlertMessage(error.response.data.message ? error.response.data.message : error.response.data.error? error.response.data.error: 'Unable to verify bank account number');
        setAlertType('error');
        setErrOpen(true);
        setOpenLoader(false);
    }
      });
  } catch (error) {
    TokenExpires(error)
    if (retry < 4) {
      setTimeout(() => {
        VerifyBank_Request_id_Profile(
          account_number,
          ifsc_code,
          bank_name,
          setAlertMessage,
          setErrOpen,
          setVerified,
          setAlertType,
          setOpenLoader,
          setVerifyResponse,
          retry + 1,
          setFieldChange,
          setFieldValue
        );
      }, 4000);
    } else {
      TokenExpires(error)
      setOpenLoader(false);
      setAlertMessage(error.response.data.message ? error.response.data.message : error.response.data.error? error.response.data.error : 'Unable to verify bank account number');
      setAlertType('error');
      setErrOpen(true);
    }
  }
};

export const BankNames = async (setBankData) => {
  try {
    await axios
      .get(`${Bankurl}/finvesta-user/banks`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('UserToken')}`
        }
      })
      .then((res) => {
        if (res.status === 200) {
          setBankData(res.data);
        }
      });
  } catch (error) {
    TokenExpires(error)
    console.log(error);
  }
};


export const FiBankList = async (setBankList) => {
  try {
    await axios
      .get(`${Bankurl}/finvesta-user/fi_banks_list`, {
        headers: {
          Authorization: `${sessionStorage.getItem('token')}`
        }
      })
      .then((res) => {
        if (res.status === 200) {
          setBankList(res.data);
        }
      })
      .catch((error) => {
        TokenExpires(error)
        console.log(error);
      });
  } catch (error) {
    TokenExpires(error)
    console.log(error);
  }
};